<div class="loading" *ngIf="loading">
  <div class="loading__progression type--flux"></div>
</div>

<span *ngIf="loading" class="sr-only">Loading...</span>
